export enum InfoBarSize {
  NORMAL =  'normal',
  WIDE = 'wide',
}